import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const CompassResourcesPage = lazy(() => import('../pages/compass-resources/page'));
const MauritransShippingPage = lazy(() => import('../pages/mauritrans-shipping/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/compass-resources',
    element: <CompassResourcesPage />,
  },
  {
    path: '/mauritrans-shipping',
    element: <MauritransShippingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;